const ballArtKeyframes = {
  frame1: {
    speed: 1.04,
    freq: 0.3,
    amp: 0.55,
  },
  frame2: {
    speed: 1.04,
    freqy: 5.19,
    freqrad: 8.5,
    ampy: 0.03,
    amprad: 5.78,
  },
  frame3: {
    speed: 3.9,
    freqy: 6.29,
    freqrad: 12.7,
    ampy: 0.02,
    amprad: 10,
  },
  frame4: {
    speed: 1.04,
    freq: 0.3,
    amp: 0.55,
  },
}

export default ballArtKeyframes